<div class="password-meter-container">
  <div [ngClass]="{'weak': score > 20 && score < 40, medium: score >= 40 && score < 70, strong: score >= 70 && score < 90, verystrong: score >= 90}"></div>
  <div [ngClass]="{medium: score >= 40 && score < 70, strong: score >= 70 && score < 90, verystrong: score >= 90}"></div>
  <div [ngClass]="{strong: score >= 70 && score < 90, verystrong: score >= 90}"></div> 
  <div [ngClass]="{verystrong: score >= 90}"></div>
</div>
<div class="strength-name">{{getStrength()}}</div>